import React from "react";

export default class DownloadDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = { visible: false };
    this.button = +new Date() + "-dropdown-clickable"; // we've using this class to exclude certain elements from hiding

    this.toggleDropdown = () =>
      this.setState((prevState) => ({
        ...prevState,
        visible: !prevState.visible,
      }));
    this.hideDropdown = (event) => {
      if (!event.target.classList.contains(this.button)) {
        this.setState((prevState) => ({ ...prevState, visible: false }));
      }
    };

    document.addEventListener("click", this.hideDropdown);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.hideDropdown);
  }

  render() {
    /* eslint-disable react/jsx-handler-names */
    return (
      <span
        onClick={this.toggleDropdown}
        className={
          "ui button pointing dropdown link item " +
          this.button +
          (this.state.visible ? " active" : "")
        }
      >
        {this.props.text}
        <i className={"dropdown icon " + this.button} />
        <div
          className={"menu transition" + (this.state.visible ? " visible" : "")}
        >
          {this.props.children}
        </div>
      </span>
    );
    /* eslint-enable react/jsx-handler-names */
  }
}
